import FormatService from "../../services/FormatService";
import { ACCOUNT_CIELOVY_UCET, ACCOUNT_INVESTICNY_UCET, ACCOUNT_MANAZOVANY_CIELOVY_UCET, ACCOUNT_MANAZOVANY_INVESTICNY_UCET, ACCOUNTS_MAP } from "./SavingEic";

function SavingEicPdfExport({values,result,chart}) {
        
    let inputs = [
        {key: 'mode', label: 'Typ', value: () => { switch (values.mode){
                case ACCOUNT_CIELOVY_UCET.id: return ACCOUNT_CIELOVY_UCET.label;
                case ACCOUNT_MANAZOVANY_INVESTICNY_UCET.id: return ACCOUNT_MANAZOVANY_INVESTICNY_UCET.label;
                case ACCOUNT_INVESTICNY_UCET.id: return ACCOUNT_INVESTICNY_UCET.label;
                case ACCOUNT_MANAZOVANY_CIELOVY_UCET.id: return ACCOUNT_MANAZOVANY_CIELOVY_UCET.label;

                default: return ''; } }},
        {key: 'period', label: 'Dĺžka investovania', value: () => { return (values.period.toString() + (values.periodUnits==='y'?'r':'m')); }},
        {key: 'revenue', label: 'Výnos p.a. (%)', value: values.revenue},
        {key: 'startFee', label: 'Vstupný poplatok (%)', value: values.startFee},
        {key: 'payment', label: 'Výška vkladu (€)', value: values.payment},
    ];

        const fonds = {
            thead: [],
            tbody: []
        };
        switch(values.mode){
            case ACCOUNT_CIELOVY_UCET.id:
                fonds.thead.push(["", "Rozdelenie fondov (%)"])

                fonds.tbody.push(["ETF", values.etfPayment])
                fonds.tbody.push(["Peňažné fondy", values.cashPayment])
                fonds.tbody.push(["Ostatné fondy", values.others])

                inputs.push({key: 'monthsForFee', label: 'Doba strhávania poplatku (m)', value: values.monthsForFee})                
                break;
            case ACCOUNT_INVESTICNY_UCET.id:
                fonds.thead.push(["", "Rozdelenie fondov (%)"])

                fonds.tbody.push(["ETF", values.etfPayment])
                fonds.tbody.push(["Peňažné fondy", values.cashPayment])
                fonds.tbody.push(["Ostatné fondy", values.others])

                break;
            case ACCOUNT_MANAZOVANY_CIELOVY_UCET.id: 
                fonds.thead.push(["", "Rozdelenie fondov (%)"])

        
                fonds.tbody.push(["ETF", values.etfPayment])         
                fonds.tbody.push(["Akciové", values.equities])
                fonds.tbody.push(["Dlhopisové", values.bonds])
                fonds.tbody.push(["Zmiešané", values.mixed])
                fonds.tbody.push(["Peňažné fondy", values.cashPayment])
                
            

                inputs.push({key: 'monthsForFee', label: 'Doba strhávania poplatku (m)', value: values.monthsForFee})
                inputs.push({key: 'managementFee', label: 'Management fee (%)', value: values.managementFee})
                inputs.push({key: 'success_fee', label: 'Success fee (%)', value: values.success_fee})
                inputs.push({key: 'success_fee_base_rate', label: 'Základná sadzba (%)', value: values.success_fee_base_rate})

                break;
            case ACCOUNT_MANAZOVANY_INVESTICNY_UCET.id:
                fonds.thead.push(["", "Rozdelenie fondov (%)", "Počet fondov"])


                fonds.tbody.push(["ETF", values.etfPayment, values.etfFundsCount])
                fonds.tbody.push(["Akciové", values.equities, values.equitiesCount])
                fonds.tbody.push(["Dlhopisové", values.bonds, values.bondsFundsCount])
                fonds.tbody.push(["Zmiešané", values.mixed, values.mixedFundsCount])
                fonds.tbody.push(["Peňažné fondy", values.cashPayment, values.cashFundsCount])

                inputs.push({key: 'managementFee', label: 'Management fee (%)', value: values.managementFee})
                inputs.push({key: 'success_fee', label: 'Success fee (%)', value: values.success_fee})
                inputs.push({key: 'success_fee_base_rate', label: 'Základná sadzba (%)', value: values.success_fee_base_rate})
                break;
        }

    return (`
    <div class="row-flex mb3">
        <div class="col-12">
            <table>
                ${inputs.map((i) => {
                    return `<tr>
                             <th>${i.label}</th>
                             <td class="text-sm-right">${typeof i.value === 'function' ? i.value() : i.value}</td>
                            </tr>`
                }).join('')}
            </table>
        </div>
    </div>  
    
    <div class="row-flex mb3">
        <div class="col-12">
            <table class="table minimal-table">
                <thead>
                    <tr>
                        ${fonds.thead.map(rows => `<tr>${rows.map(row => `<th>${row}</th>`).join("")}</tr>`).join("")}
                    </tr>
                </thead>
                <tbody>
                        ${fonds.tbody.map(rows => `<tr>${rows.map((row,idx) => {
                            return `<td class="${idx == 0 ? "text-right": ""}">${row}</td>`}).join("")
                        }</tr>`).join("")}                 
        
                </tbody>
            </table>
        </div>
    </div>
    <div class="row-flex mb3">
         <div class="col-12">          
              
            <div class="card">
                 <div class="card-body">
                    <h3>${ACCOUNTS_MAP[Number(values.mode)]?.output}</h3>
                    <div class="table-responsive">
                        <table class="table styled-table">
                            <tbody>
                            <tr>
                                <th>Hodnota investície na konci investičného horiznotu</th>
                                <td class="text-right"><b>${FormatService.round(result.endValue)}</b> €</td>
                            </tr>
                            <tr>
                                <th>Absolútny výnos</th>
                                <td class="text-right"><b>${FormatService.round(result.absolutProfit*100,2)}</b> %</td>
                            </tr>
                            <tr>
                                <th>Výnos p.a.</th>
                                <td class="text-right"><b>${FormatService.round(result.profit*100,2)}</b> %</td>
                            </tr>
                            <tr>
                                <th>Návratnosť v mesiacoch (hodnota účtu prevyšuje sumu vkladov)</th>
                                <td class="text-right"><b>${FormatService.round(result.monthReturn)}</b> m</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                 </div>
              </div>
              
         </div>
    </div>
    
    <div class="row-flex">
        <div class="col-12 text-center">
            ${chart ? chart.getSVG() : ''}
        </div>
    </div>
    `);
}

export default SavingEicPdfExport;